import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface ClientDialogProps {
    open: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}

const ClientDialog: React.FC<ClientDialogProps> = ({ open, title, onClose, children }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='contained'>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export { ClientDialog };
